"use client";

import { c as _c } from "react/compiler-runtime";
import { RainbowButton } from "@/components/magicui/rainbow-button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useCreateSignInRedirectURL } from "@/hooks/use-create-sign-in-redirect-url";
import { useAuth } from "@clerk/nextjs";
import { useRouter } from "next/navigation";
import { useState } from "react";
import AffiliateSignUpForm from "./affiliate-sign-up-form";
export default function AffiliateSignUpDialog() {
  const $ = _c(11);
  const {
    userId
  } = useAuth();
  const router = useRouter();
  const signInUrl = useCreateSignInRedirectURL();
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] !== router || $[1] !== signInUrl || $[2] !== userId) {
    t0 = function handleClick() {
      if (!userId) {
        router.push(signInUrl);
        return;
      }
      setIsOpen(true);
    };
    $[0] = router;
    $[1] = signInUrl;
    $[2] = userId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleClick = t0;
  let t1;
  if ($[4] !== handleClick) {
    t1 = <RainbowButton className="my-6" onClick={handleClick}>Join affiliate program</RainbowButton>;
    $[4] = handleClick;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogHeader><DialogTitle>Join Affiliate program</DialogTitle><DialogDescription>Enter your payment details below where we will send you your earnings.</DialogDescription></DialogHeader>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogContent>{t2}<AffiliateSignUpForm onCloseAction={() => setIsOpen(false)} /></DialogContent>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isOpen || $[9] !== t1) {
    t4 = <Dialog open={isOpen} onOpenChange={setIsOpen}>{t1}{t3}</Dialog>;
    $[8] = isOpen;
    $[9] = t1;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}